import {DrillDownStatistics} from '../../../../../types/api/drillDown';

function isRowAboveMinYear(row: DrillDownStatistics, minYear: number): boolean {
  const yearLevel = row.levels.find((l) => l.name === 'year');
  if (yearLevel === undefined) {
    return true;
  }
  const year = Number(yearLevel.value);
  return Number.isFinite(year) && year >= minYear;
}

/**
 * Filters statisticsAggregated to only include rows where year level (if present) is >= minYear.
 */
export function filterStatisticsAggregatedByMinYear(
  rows: DrillDownStatistics[],
  minYear: number
): DrillDownStatistics[] {
  return rows.filter((row) => isRowAboveMinYear(row, minYear));
}
